// contexts/ChatBundleContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useChatBundle } from '../hooks/useChatBundle';

const ChatBundleContext = createContext(null);

export const ChatBundleProvider = ({ children }) => {
  const isLoggedIn = localStorage.getItem("token") && localStorage.getItem("meData");
  const { enableBundle, loading, bundleData } = useChatBundle(isLoggedIn);
  const [isEnabled, setIsEnabled] = useState(isLoggedIn);

  // Auto-enable if already logged in
  useEffect(() => {
    if (isLoggedIn && !isEnabled) {
      enableBundle();
      setIsEnabled(true);
    }
  }, [isLoggedIn, enableBundle, isEnabled]);

  return (
    <ChatBundleContext.Provider value={{ loading, bundleData, enableBundle }}>
      {children}
    </ChatBundleContext.Provider>
  );
};

export const useChatBundleContext = () => {
  const context = useContext(ChatBundleContext);
  if (!context) {
    throw new Error('useChatBundleContext must be used within ChatBundleProvider');
  }
  return context;
};